import React from "react";
import type { FieldError } from "react-hook-form";
import { get } from "react-hook-form";
import { useFormContext } from "react-hook-form";

import type { FieldLabelProps } from "@braze/beacon-core";
import { FieldLabel } from "@braze/beacon-core";

const getStatusFromHookValidation = (error?: FieldError) =>
  ({
    status: error ? "danger" : undefined,
    statusText: error?.message as string,
  }) as const;

export const HookFieldLabel = ({ name, ...rest }: FieldLabelProps & { name: string }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const formStatus = getStatusFromHookValidation(get(errors, name));

  return <FieldLabel {...formStatus} {...rest} />;
};
